import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
  inject,
} from '@angular/core';
import { Menu, NavService } from '../../services/navservice';
import { SwitcherComponent } from '../switcher/switcher.component';
import { NgbModal, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { AppStateService } from '../../services/app-state.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, Subject, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { loggedUserActions } from '../../../store/logged_user/logged_user.actions';
import { User } from '../../../models/user.model';
import { jwtDecode } from 'jwt-decode';
import { CognitoService } from '../../auth/cognito.service';
import { ToastrService } from 'ngx-toastr';
interface Item {
  id: number;
  name: string;
  type: string;
  title: string;
  // Add other properties as needed
}
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  private store = inject(Store);
  private toastr = inject(ToastrService);
  private cognitoService = inject(CognitoService);

  cartItemCount: number = 5;
  notificationCount: number = 5;
  public isCollapsed = true;
  collapse: any;
  closeResult = '';
  themeType: string | undefined;

  selectedItem: string  | null ='selectedItem'
  isOpen: boolean = false;
  constructor(
    private appStateService: AppStateService,
    public navServices: NavService,
    private elementRef: ElementRef,
    public renderer: Renderer2,
    public modalService:NgbModal,
    private router: Router, private activatedRoute: ActivatedRoute
  ) {}

  toggleSidebar() {
    let html = this.elementRef.nativeElement.ownerDocument.documentElement;
    if (html?.getAttribute('data-toggled') == 'true') {
      document.querySelector('html')?.getAttribute('data-toggled') ==
        'icon-overlay-close';
    }
    else if (html?.getAttribute('data-nav-style') == 'menu-click') {
      html?.setAttribute(
        'data-toggled',
        html?.getAttribute('data-toggled') == 'menu-click-closed'
          ? ''
          : 'menu-click-closed'
      );
    } else if (html?.getAttribute('data-nav-style') == 'menu-hover') {
      html?.setAttribute(
        'data-toggled',
        html?.getAttribute('data-toggled') == 'menu-hover-closed'
          ? ''
          : 'menu-hover-closed'
      );
    } else if (html?.getAttribute('data-nav-style') == 'icon-click') {
      html?.setAttribute(
        'data-toggled',
        html?.getAttribute('data-toggled') == 'icon-click-closed'
          ? ''
          : 'icon-click-closed'
      );
    } else if (html?.getAttribute('data-nav-style') == 'icon-hover') {
      html?.setAttribute(
        'data-toggled',
        html?.getAttribute('data-toggled') == 'icon-hover-closed'
          ? ''
          : 'icon-hover-closed'
      );
    }
    else if (html?.getAttribute('data-vertical-style') == 'overlay') {
      html?.setAttribute(
        'data-vertical-style','overlay' 
      );
      html?.setAttribute(
        'data-toggled', html?.getAttribute('data-toggled') == 'icon-overlay-close'
        ? ''
        : 'icon-overlay-close'
      );
    } else if (html?.getAttribute('data-vertical-style')  == 'overlay') {
      document.querySelector('html')?.getAttribute('data-toggled') != null
        ? document.querySelector('html')?.removeAttribute('data-toggled')
        : document
            .querySelector('html')
            ?.setAttribute('data-toggled', 'icon-overlay-close');
    } else if (html?.getAttribute('data-vertical-style') == 'closed') {
      html?.setAttribute(
        'data-toggled',
        html?.getAttribute('data-toggled') == 'close-menu-close'
          ? ''
          : 'close-menu-close'
      );
    } else if (html?.getAttribute('data-vertical-style') == 'icontext') {
      html?.setAttribute(
        'data-toggled',
        html?.getAttribute('data-toggled') == 'icon-text-close'
          ? ''
          : 'icon-text-close'
      );
    } else if (html?.getAttribute('data-vertical-style') == 'detached') {
      html?.setAttribute(
        'data-toggled',
        html?.getAttribute('data-toggled') == 'detached-close'
          ? ''
          : 'detached-close'
      );
    }else if (html?.getAttribute('data-vertical-style') == 'doublemenu') {
      html?.setAttribute('data-toggled', html?.getAttribute('data-toggled') == 'double-menu-close' && document.querySelector(".slide.open")?.classList.contains("has-sub")? 'double-menu-open': 'double-menu-close' );
    } 

    if (window.innerWidth <= 992) {
      html?.setAttribute(
        'data-toggled',
        html?.getAttribute('data-toggled') == 'open' ? 'close' : 'open'
      );
    }
  }

  userInfo = {
    name: '',
    surname: '',
    role: ''
  }
  
  private destroy$: Subject<void> = new Subject();

  ngOnInit(): void {
    this.store.dispatch(loggedUserActions.resetLoggedUser());

    this.userInfo = {
      name: '',
      surname: '',
      role: ''
    }
    
    this.cognitoService.fetchUserInfo();

    this.store.select('loggedUser')
    .pipe(
      takeUntil(this.destroy$)
    )
    .subscribe((data) => {
      if(data) {
        this.userInfo = data
      }
    })

    // if(localStorage.getItem('access_token')) {
    //   this.store.dispatch(loggedUserActions.setLoggedUser({data: jwtDecode(localStorage.getItem('access_token')!)}));
    
    //   this.store.select('loggedUser')
    //   .pipe(
    //     takeUntil(this.destroy$)
    //   )
    //   .subscribe((data) => {
    //     this.userInfo = data
    //   })
    // }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  //! Get name of logged user
  getLoggedUserName() {
    if(this.userInfo.name && this.userInfo.surname) {
      return this.userInfo.name + ' ' + this.userInfo.surname
    }
    return null
  }

  getLoggedUserRole() {
    if(this.userInfo.role) {
      return this.userInfo.role;
    }
    return null;
  }

  logOut() {
    this.cognitoService.signOut()
    .then(() => {
      this.store.dispatch(loggedUserActions.resetLoggedUser());
      this.router.navigate(['/auth/login']);
    })
    .catch((err:any) => {
      this.toastr.error('Si è verificato un errore: ' + err, '', {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      })
    })
  }
}
